export const isuGroupValidation = {
  required: 'Не указана группа ИСУ',
  maxLength: {
    message: 'Группа ИСУ не должна иметь больше 10 символов',
    value: 10,
  },
};
